import { create } from "zustand";

import { PickingConflictData } from "../components/PickingConflictModal";

type PickingUIStore = {
  shouldShowOrderCompletionWarning: boolean;
  endPickingConflictData: PickingConflictData | null;
};

type PickingUIStoreWithMethods = PickingUIStore & {
  setPickingUIState(pickingUIState: Partial<PickingUIStore>): void;
  reset(): void;
};

const initialState: PickingUIStore = {
  shouldShowOrderCompletionWarning: false,
  endPickingConflictData: null,
};

export const usePickingUIStore = create<PickingUIStoreWithMethods>()((set) => ({
  ...initialState,
  setPickingUIState(pickingUIState) {
    set(pickingUIState);
  },
  reset() {
    set(initialState);
  },
}));
